import { cn } from "utils/styling";

import type { JobLogEntry } from "../lib/parseJobLogEvent";

import {
  formatJobLogTime,
  jobLogLevelBorderClass,
  jobLogLevelColorClass,
  toScriptFileName,
} from "../model/jobLogLevels";

type TransientJobLogLineProps = {
  line: JobLogEntry;
};

export const TransientJobLogLine = ({ line }: TransientJobLogLineProps) => {
  const isCritical = line.level === "CRITICAL";
  const levelColorClass = jobLogLevelColorClass(line.level);
  const metaClassName = isCritical ? levelColorClass : "text-core-grey-200";
  const messageClassName = isCritical ? levelColorClass : "text-lds-foreground-inverse";
  const meta = [
    formatJobLogTime(line.time),
    toScriptFileName(line.module),
    line.line != null ? `in line ${line.line}` : undefined,
    line.functionName ? `in ${line.functionName}` : undefined,
  ].filter((part) => typeof part === "string");

  return (
    <div className={cn("border-l-4 py-3 pl-4 border-b-ds-soft", jobLogLevelBorderClass(line.level))}>
      <p>
        {line.level ? (
          <span className={cn("font-ds-number-semibold-md", jobLogLevelColorClass(line.level))}>{line.level}</span>
        ) : null}
        {line.level && meta.length > 0 ? "  " : null}
        {meta.length > 0 ? (
          <span className={cn("font-ds-number-regular-md", metaClassName)}>{meta.join("  ")}</span>
        ) : null}
      </p>
      <p className={cn("mt-2 whitespace-pre-wrap break-all font-ds-body-regular-lg", messageClassName)}>
        {line.message}
      </p>
    </div>
  );
};
